import { render, staticRenderFns } from "./file-load.vue?vue&type=template&id=5a3a3c19&"
import script from "./file-load.vue?vue&type=script&lang=js&"
export * from "./file-load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports